export function getPrefixCls(suffixCls) {
  return suffixCls ? "pi-".concat(suffixCls) : "pi";
}